import { createFileRoute } from "@tanstack/react-router";
import { Badge, EmptyState, PageHeader } from "@oms/ui";
import { PageShell } from "@/components/pages/page-shell";

export const Route = createFileRoute("/app/inventory")({
  component: InventoryPage,
});

function InventoryPage() {
  return (
    <PageShell>
      <PageHeader
        title="Inventory"
        description="Track stock levels and sync status across channels."
        actions={<Badge variant="neutral">Coming soon</Badge>}
      />
      <EmptyState
        title="Coming soon"
        description="Inventory management is under development. Stock tracking and multi-channel sync will be available in a future update."
      />
    </PageShell>
  );
}
